import Vue from 'vue'

/**
 * Get the error from a response.
 *
 * @param {Response} response The Vue-resource Response that we will try to get errors from.
 */
Vue.prototype.$getError = function (response) {
  return response.body['error_description']
    ? response.body.error_description
    : response.statusText
}

Vue.prototype.$getTermIndex = function (term) {
  switch (term) {
    case 'licence_renew':
      return 'Renouvellements'
      break
    case 'licence_new':
      return 'Inscriptions'
      break
    case 'licence_club':
      return 'Licence club'
      break
    default:
      return "Autres"
      break
  }
}





// WEBPACK FOOTER //
// ./src/utils.js